import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "context";

function SimulateCustomer() {
  const navigate = useNavigate();
  const { saveAuthData } = useAuth();
  const [searchParams] = useSearchParams();

  React.useEffect(() => {
    if (searchParams.get("data")) {
      const data = JSON.parse(atob(searchParams.get("data")));
      saveAuthData(data.tokens);
    }
    navigate("/dashboard", {
      replace: true,
    });
  }, [searchParams]);
  return <></>;
}

export default SimulateCustomer;
